/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {selectItemsUpdatedEndpointTopicUrl, WellStompService} from "@well/shared-providers";
import {LocalStorageService, SessionStorageService} from "ngx-webstorage";
import {EnvironmentService} from "@irian-ro/util-environment";
import {Observable, Subject} from "rxjs";
import { SelectItemsVoModel } from "@well/common-libs/select-items/domain";

@Injectable()
export class SelectItemsStompService extends WellStompService {

  private selectItemsUpdatedTopicSubscription: any | undefined = undefined;

  private selectItemsUpdate$: Subject<SelectItemsVoModel[]> = new Subject();

  constructor(private environmentService: EnvironmentService,
              private localStorageService: LocalStorageService,
              private sessionStorageService: SessionStorageService) {
    super(environmentService.getEnvironmentProperty('wsAdministrationEndpointUrl'),
      localStorageService,
      sessionStorageService);
  }

  stompTopicsSubscribe(locale: string) {
    this.register(this.subscribeToSelectItemsUpdated(locale));
  }

  stompTopicsUnsubscribe() {
    if (this.selectItemsUpdatedTopicSubscription) {
      this.selectItemsUpdatedTopicSubscription.unsubscribe();
    }
  }

  getSelectItemsUpdateObservable(): Observable<SelectItemsVoModel[]> {
    return this.selectItemsUpdate$.asObservable();
  }

  private subscribeToSelectItemsUpdated(locale: string) {
    return (stompClient: any) => {
      this.selectItemsUpdatedTopicSubscription = stompClient.subscribe(
        selectItemsUpdatedEndpointTopicUrl(locale),
        (res: any) => {
          const selectItems: SelectItemsVoModel[] = JSON.parse(res.body);
          this.selectItemsUpdate$.next(selectItems);
        });
    };
  }
}
